module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.showTopMenu) ? _c('div', {
    staticClass: "app-menu"
  }, [(_vm.isPc()) ? _c('div', {
    staticClass: "app-menu-pc"
  }, [(false) ? _c('a', {
    staticClass: "page_logo",
    attrs: {
      "href": "/"
    }
  }, [(_vm.showTopMenu == 'white') ? _c('img', {
    staticClass: "page_logo_white",
    attrs: {
      "src": "https://static-image.xfz.cn/1628943750731/logo_fz_white.png",
      "alt": "logo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTopMenu == 'red') ? _c('img', {
    staticClass: "page_logo_red",
    attrs: {
      "src": require("./assets/img/pc/fz_red_logo.png"),
      "alt": "logo"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "page_right_top_menu",
    on: {
      "click": function($event) {
        _vm.toggleRightMenu()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1628999132570/icon_menu.jpg",
      "alt": "menu"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showRightMenu) ? _c('div', {
    staticClass: "page-menu-mask"
  }, [_c('div', {
    staticClass: "menu-close",
    on: {
      "click": function($event) {
        _vm.toggleRightMenu()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/pc/close.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "page-menu-mask-ul"
    }
  }, [_c('li', {
    staticClass: "about",
    class: {
      'li-active': _vm.currentMenu == '/about'
    }
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("关于凡卓")])]), _vm._v(" "), _c('li', {
    staticClass: "team",
    class: {
      'li-active': _vm.currentMenu == '#team'
    }
  }, [_c('a', {
    attrs: {
      "href": "/#team"
    }
  }, [_vm._v("凡卓团队")])]), _vm._v(" "), _c('li', {
    staticClass: "deal",
    class: {
      'li-active': _vm.currentMenu == '/deal'
    }
  }, [_c('a', {
    attrs: {
      "href": "/deal"
    }
  }, [_vm._v("凡卓交易")])]), _vm._v(" "), _c('li', {
    staticClass: "viewpoint",
    class: {
      'li-active': _vm.currentMenu == '/viewpoint'
    }
  }, [_c('a', {
    attrs: {
      "href": "/viewpoint"
    }
  }, [_vm._v("凡卓观点")])]), _vm._v(" "), _c('li', {
    staticClass: "empower",
    class: {
      'li-active': _vm.currentMenu == '/empower'
    }
  }, [_c('a', {
    attrs: {
      "href": "/empower"
    }
  }, [_vm._v("凡卓赋能")])]), _vm._v(" "), _c('li', {
    staticClass: "news",
    class: {
      'li-active': _vm.currentMenu == '/news'
    }
  }, [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('li', {
    staticClass: "contact",
    class: {
      'li-active': _vm.currentMenu == '/contact'
    }
  }, [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("联系我们")])])])]) : _vm._e()]) : _c('div', {
    staticClass: "app-menu-mobile"
  }, [_c('a', {
    staticClass: "page_logo",
    attrs: {
      "href": "/"
    }
  }, [(_vm.showTopMenu == 'white') ? _c('img', {
    staticClass: "page_logo_white",
    attrs: {
      "src": require("./assets/img/mobile/fz_logo_white.png"),
      "alt": "logo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTopMenu == 'red') ? _c('img', {
    staticClass: "page_logo_red",
    attrs: {
      "src": require("./assets/img/mobile/fz_logo_red.png"),
      "alt": "logo"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page_right_top_menu",
    on: {
      "click": function($event) {
        _vm.toggleRightMenu()
      }
    }
  }, [(_vm.showTopMenu == 'white') ? _c('img', {
    attrs: {
      "src": require("./assets/img/mobile/menu_icon_white.png"),
      "alt": "menu"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTopMenu == 'red') ? _c('img', {
    attrs: {
      "src": require("./assets/img/mobile/menu_icon_red.png"),
      "alt": "menu"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showRightMenu) ? _c('div', {
    staticClass: "page-menu-mask"
  }, [_c('div', {
    staticClass: "menu-close",
    on: {
      "click": function($event) {
        _vm.toggleRightMenu()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/pc/close.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "page-menu-mask-ul"
    }
  }, [_c('li', {
    staticClass: "about",
    class: {
      'li-active': _vm.currentMenu == '/about'
    }
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("关于凡卓")])]), _vm._v(" "), _c('li', {
    staticClass: "team",
    class: {
      'li-active': _vm.currentMenu == '#team'
    }
  }, [_c('a', {
    attrs: {
      "href": "/#team"
    }
  }, [_vm._v("凡卓团队")])]), _vm._v(" "), _c('li', {
    staticClass: "deal",
    class: {
      'li-active': _vm.currentMenu == '/deal'
    }
  }, [_c('a', {
    attrs: {
      "href": "/deal"
    }
  }, [_vm._v("凡卓交易")])]), _vm._v(" "), _c('li', {
    staticClass: "viewpoint",
    class: {
      'li-active': _vm.currentMenu == '/viewpoint'
    }
  }, [_c('a', {
    attrs: {
      "href": "/viewpoint"
    }
  }, [_vm._v("凡卓观点")])]), _vm._v(" "), _c('li', {
    staticClass: "empower",
    class: {
      'li-active': _vm.currentMenu == '/empower'
    }
  }, [_c('a', {
    attrs: {
      "href": "/empower"
    }
  }, [_vm._v("凡卓赋能")])]), _vm._v(" "), _c('li', {
    staticClass: "news",
    class: {
      'li-active': _vm.currentMenu == '/news'
    }
  }, [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('li', {
    staticClass: "contact",
    class: {
      'li-active': _vm.currentMenu == '/contact'
    }
  }, [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("联系我们")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "keep-alive": "",
      "transition": "",
      "transition-mode": "out-in"
    }
  }), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03690b80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 212
// module chunks = 0